// extracted by mini-css-extract-plugin
export default {"Section":"PrivacySettings_Section__Y+nhg","SectionName":"PrivacySettings_SectionName__Ky3FB","Table":"PrivacySettings_Table__tkm9x","Row":"PrivacySettings_Row__26IQE"};